import ConfigRaw from '../config.json';
import store from '@/store';
import { isHostIPAddress } from '@/utilities/Url';

interface Config {
  adminUiEndpoint?: string;
  apiEndpoint?: string;
  googleMapsApiKey?: string;
  sentryDsn?: string;
  facebookID?: string;
  leaderboardUI?: string;
}

export class ConfigData {
  static get apiEndpoint(): string | undefined {
    return (ConfigRaw as Config).apiEndpoint;
  }

  static get googleMapsApiKey(): string | undefined {
    return (ConfigRaw as Config).googleMapsApiKey;
  }

  static get adminUiEndpoint(): string | undefined {
    const host = store.getters['utility/host'] ?? (typeof window !== 'undefined' ? window.location.hostname : '');
    const isLocalEnvironment =
      host === 'localhost' || (host.startsWith('localhost') && host.includes(':')) || isHostIPAddress(host);
    // if local environment then we want to use our env endpoint settings
    if (isLocalEnvironment) {
      return (ConfigRaw as Config).adminUiEndpoint;
    }
    return `https://${host}`;
  }

  static get sentryDsn(): string | undefined {
    return (ConfigRaw as Config).sentryDsn;
  }

  static get facebookID(): string | undefined {
    return (ConfigRaw as Config).facebookID;
  }

  static get leaderboardUI(): string {
    const url = (ConfigRaw as Config).leaderboardUI;
    if (!url || url === '') {
      throw new Error('Leaderboard URL has to be provided !');
    } else {
      return url;
    }
  }
}
